import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MunirUddinMahbub from "../../Assets/images/Munir Uddin Mahbub.png";

const Navbar = () => {
    const [nav, setNav] = useState(true);
    React.useEffect(() => {
        var prevScrollpos = window.pageYOffset;

        const changeNavbarBg = () => {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos) {
                setNav(true);

            } else {
                setNav(false);
            }
            prevScrollpos = currentScrollPos;
        };
        window.addEventListener('scroll', changeNavbarBg);
    }, []);

    return (
        <div id='_navbar-area'>
            <div className={nav === true ? 'topziro' : 'top-65'}>
                <nav className='navbar navbar-expand-lg navbar-light bg-light'>
                    {/* <!-- Container wrapper --> */}
                    <div className="container-fluid">
                        {/* <!-- Toggle button --> */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-mdb-toggle="collapse"
                            data-mdb-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <i className="fas fa-bars" />
                        </button>

                        {/* <!-- Collapsible wrapper --> */}
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            {/* <!-- Navbar brand --> */}
                            <a className="navbar-brand mt-2 mt-lg-0" href="/">
                                MAHBUB HASAN
                            </a>
                            {/* <!-- Left links --> */}
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                <li className="nav-item">
                                    <Link className="nav-link" to="/">Home</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/portfolio">Projects</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/blog">Blogs</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/contact">Contact</Link>
                                </li>
                                {/* <li className="nav-item">
                                    <Link className="nav-link" to="dashboard">Dashboard</Link>
                                </li> */}
                            </ul>
                            {/* <!-- Left links --> */}
                        </div>
                        {/* <!-- Collapsible wrapper --> */}
                        <div className="">
                            <a href="https://drive.google.com/file/d/1t3FfYvgnAqAQRfzFd5n2ioedHNtyryrA/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                                <button type="button" class="btn btn-primary mr-5 ">My Resume</button>
                            </a>
                        </div>
                        {/* <!-- Right elements --> */}
                        <div className="d-flex align-items-center text-success">
                            {/* <!-- Icon --> */}
                            <a className="text-reset me-3" href="tel:+8801966945992">
                                {/* <i className="fas fa-shopping-cart" /> */}
                                {/* <i className="fas fa-phone"></i> */}
                                <i className="fas fa-phone-alt"> +8801966945992</i>
                            </a>

                            {/* <!-- Notifications --> */}
                            {/* <a
                                className="text-reset me-3 dropdown-toggle hidden-arrow"
                                href="/"
                                id="navbarDropdownMenuLink"
                                role="button"
                                data-mdb-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="fas fa-bell" />
                                <span className="badge rounded-pill badge-notification bg-danger">
                                    1
                                </span>
                            </a> */}
                            {/* <ul
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby="navbarDropdownMenuLink"
                            >
                                <li>
                                    <a className="dropdown-item" href="/">
                                        Some news
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="/">
                                        Another news
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="/">
                                        Something else here
                                    </a>
                                </li>
                            </ul> */}

                            {/* <!-- Avatar --> */}
                            <a
                                className="dropdown-toggle d-flex align-items-center hidden-arrow"
                                href="/"
                                id="navbarDropdownMenuLink"
                                role="button"
                                data-mdb-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <img
                                    src={MunirUddinMahbub}
                                    className="rounded-circle"
                                    height="25"
                                    alt=""
                                    loading="lazy"
                                />
                            </a>
                            {/* <ul
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby="navbarDropdownMenuLink"
                            >
                                <li>
                                    <a className="dropdown-item" href="/">
                                        My profile
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="/">
                                        Settings
                                    </a>
                                </li>
                                <li>
                                    <a className="dropdown-item" href="/">
                                        Logout
                                    </a>
                                </li>
                            </ul> */}
                        </div>
                        {/* <!-- Right elements --> */}
                    </div>
                    {/* <!-- Container wrapper --> */}
                </nav>
            </div>
        </div>
    );
};

export default Navbar;
